// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"997ab185","787":"60aef25f"}[chunkId] + ".chunk.js";
};